<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="'Edit Pro'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (loaded) {
      <tidy-card>
        <form [formGroup]="form">
          <tidy-row class="field-bottom-padding field-top-padding">
            <tidy-input
              [label]="'Name'"
              formControlName="name"
              [form]="form.controls.name"
              [icon]="'assets/svg/person-circle.svg'"
              [submitted]="submitted"
              [errorMessage]="'Please enter a name.'" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-input
              [label]="'Email'"
              formControlName="email"
              type="email"
              [form]="form.controls.email"
              [icon]="'assets/svg/mail.svg'"
              [submitted]="submitted"
              [errorMessage]="'Please enter a valid email.'" />
          </tidy-row>
          <tidy-row>
            <tidy-input-international-phone
              formControlName="phone"
              [label]="'Phone Number'"
              [form]="form.controls.phone"
              [inputMode]="'numeric'"
              [submitted]="submitted"
              [errorMessage]="'Please enter a valid phone number.'"
              [icon]="'assets/svg/phone-portrait.svg'"
              [defaultCountryCode]="proCountryCode"
              [initialMask]="{ mask: '[00000000000000000000000]' }"
              (countryCodeChange)="onCountryCodeChange($event)" />
          </tidy-row>
        </form>
      </tidy-card>
    }

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    <tidy-button
      [text]="'Save Changes'"
      [action]="boundUpdate"
      class="primary" />
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
